import { createStore } from 'vuex'

const USER_INFO = 'USER_INFO';
const ROOT_MENU = 'ROOT_MENU';
// const SUB_MENU = 'SUB_MENU';
// const FINAL_MENU = 'FINAL_MENU';


export default createStore({
    state: {
        userInfo: window.SessionStorage.get(USER_INFO) || {},
        rootMenu: window.SessionStorage.get(ROOT_MENU) || '',
        // subMenu: window.SessionStorage.get(SUB_MENU) || '0',
        // finalMenu: window.SessionStorage.get(FINAL_MENU) || '0'
    },
    getters: {
    },
    mutations: {
        setUserInfo (state, _userInfo) {
            state.userInfo = _userInfo;
            window.SessionStorage.set(USER_INFO, _userInfo);
        },
        setRootMenu (state, _rootMenu) {
            state.rootMenu = _rootMenu;
            window.SessionStorage.set(ROOT_MENU, _rootMenu);
        }
        // setSubMenu (state, _subMenu) {
        //   state.subMenu = _subMenu;
        //   window.SessionStorage.set(SUB_MENU, _subMenu);
        // },
        // setFinalMenu (state, _finalMenu) {
        //   state.finalMenu = _finalMenu;
        //   window.SessionStorage.set(FINAL_MENU, _finalMenu);
        // }
    },
    actions: {
    },
    modules: {
    }
})
